module.exports = __webpack_public_path__ + "img/Dechet.1971e964.svg";